// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_E7phx","imgStyle":"imgStyle_TBLHp"};